<template>
	<button
			 class="app-button relative h-auto inline-flex items-center gap-2 rounded justify-center transition ease-in-out duration-150"
			 :class="_buttonClass"
			 :type="type"
			 :disabled="_disabled"
			 @click="$emit('click', $event)">

		<slot v-if="!loading || !loading && !replace">
			{{ text }}
		</slot>

		<template v-if="loading">
			<slot name="loading-text">
				<span v-if="loadingText">{{ loadingText }}</span>
			</slot>

			<AppSpinner small />
		</template>

	</button>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'
import { makeProp } from '@/utils/props';
import Props from '@/support/constants/props';
import AppSpinner from '@/components/Spinner.vue';
import { ButtonVariant } from '@/support/buttons';

export default defineComponent({
	name: 'AppButton',
	components: {
		AppSpinner
	},
	props: {
		buttonClass: makeProp(Props.ArrayObjectString),
		variant: makeProp(Props.String as PropType<ButtonVariant>, 'primary'),
		block: makeProp(Props.Boolean, false),
		size: makeProp(Props.String as PropType<'sm' | 'md' | 'lg'>, 'md'),
		type: makeProp(Props.String as PropType<"button" | "submit" | "reset">, 'button'),
		loading: makeProp<boolean>(Props.Boolean, false),
		disabled: makeProp<boolean>(Props.Boolean, false),
		text: makeProp(Props.String),
		loadingText: makeProp(Props.String),
		replace: makeProp(Props.Boolean, true)
	},
	computed: {
		_disabled(): boolean {
			return !! this.disabled || !! this.loading;
		},
		_buttonClass(): (string | object)[] {
			return [
				this.buttonClass || '',
				{
					'w-full': this.block,

					'text-white shadow-sm shadow-black bg-primary-600 border border-primary-700 hover:bg-primary-700 hover:shadow-md hover:shadow-black/50 hover:text-white focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:shadow-none disabled:bg-primary-300 disabled:text-white disabled:border-primary-300': this.variant === 'primary',

					'text-black shadow-sm shadow-black bg-accent-400 border border-accent-500 hover:bg-accent-500 hover:shadow-md hover:shadow-black/50 hover:text-black focus:outline-hidden focus:ring-gray-400 focus:ring-2 focus:ring-offset-2 disabled:shadow-none disabled:bg-accent-300 disabled:text-gray-600 disabled:border-accent-300': ['cta', 'secondary'].includes(this.variant || ''),

					'bg-transparent disabled:text-link/40 text-link font-medium': this.variant === 'link',

					'px-6 py-3 h-10 max-h-12': this.size === 'sm',
					'px-8 py-4 h-14 max-h-14 text-lg': this.size === 'md',
					'px-12 py-6 h-16 max-h-16 text-xl': this.size === 'lg',
				}
			]
		}
	}
})
</script>
